// @flow
import * as React from 'react';
import { createClient, Provider as UrlqProvider } from 'urql';

type SearchProviderProps = {
  children?: React.Node,
};

const urqlClient = createClient({
  url: `https://${process.env.GATSBY_SHOPIFY_STORE_URL}/api/2021-07/graphql.json`,
  fetchOptions: {
    headers: {
      'X-Shopify-Storefront-Access-Token':
        process.env.GATSBY_STOREFRONT_ACCESS_TOKEN,
    },
  },
});

// eslint-disable-next-line
export function SearchProvider({ children }: SearchProviderProps) {
  return <UrlqProvider value={urqlClient}>{children}</UrlqProvider>;
}
